/**
 * Helper per determinare il prefisso API corretto basato sul contesto (tenant vs legacy)
 * 
 * Uso:
 * import { getApiPrefix, isTenantContext } from '../utils/apiHelper';
 * 
 * const prefix = getApiPrefix();
 * api.get(`${prefix}/invoices`)
 * 
 * Per il modulo magazzino:
 * api.get(`${prefix}/magazzino/articoli`)
 */

/**
 * Verifica se siamo in contesto tenant
 * @returns {boolean} true se siamo in contesto tenant
 */
export const isTenantContext = () => {
  const currentTenant = localStorage.getItem('currentTenant');
  return !!currentTenant;
};

/**
 * Ottiene il prefisso API corretto
 * - In contesto tenant: '/tenant'
 * - In contesto legacy: ''
 * @returns {string} il prefisso da usare per le API
 */
export const getApiPrefix = () => {
  return isTenantContext() ? '/tenant' : '';
};

/**
 * Ottiene lo slug del tenant corrente
 * @returns {string|null} lo slug del tenant o null
 */
export const getCurrentTenantSlug = () => {
  return localStorage.getItem('currentTenant');
};

/**
 * Ottiene le informazioni del tenant corrente
 * @returns {object|null} le info del tenant o null
 */
export const getCurrentTenantInfo = () => {
  const info = localStorage.getItem('tenant');
  return info ? JSON.parse(info) : null;
};

/**
 * Costruisce l'URL completo per un endpoint API
 * @param {string} endpoint - L'endpoint senza prefisso (es. '/invoices' o '/magazzino/articoli')
 * @returns {string} L'URL completo con prefisso tenant se necessario
 */
export const buildApiUrl = (endpoint) => {
  const prefix = getApiPrefix();
  // Assicurati che l'endpoint inizi con /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${prefix}${normalizedEndpoint}`;
};

export default {
  isTenantContext,
  getApiPrefix,
  getCurrentTenantSlug,
  getCurrentTenantInfo,
  buildApiUrl
};
